import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'bo-proficency-assessment',
  templateUrl: './proficency-assessment.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class ProficencyAssessmentComponent {
  valid = input(false);
  score = input<number>(0);
  levels = input<{ intermediate: number; expert: number }>({
    intermediate: 50,
    expert: 95,
  });

  level = computed(() =>
    this.score() > this.levels().expert
      ? 'level.expert'
      : this.score() > this.levels().intermediate
        ? 'level.intermediate'
        : 'level.beginner',
  );
}
